export default __webpack_public_path__ + "static/media/TakeATour.6132ce97.svg";